"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractSecretBox = void 0;
class AbstractSecretBox {
}
exports.AbstractSecretBox = AbstractSecretBox;
//# sourceMappingURL=abstract-secret-box.js.map